module.exports = ".radio_flex {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n"